/* eslint-disable @typescript-eslint/naming-convention */
export enum FIELD_NAMES {
  EMAIL = "email",
  FULL_NAME = "fullName",
  MOBILE_NUMBER = "phone",
  PASSWORD = "password",
  PASSWORD_REPEAT = "repeatedPassword",
  AGREEMENT = "agreement",
  RECAPTCHA = "recaptcha",
  MARKETING = "marketing",
}

export const REGISTRATION_INITIAL_VALUES = {
  [FIELD_NAMES.EMAIL]: "",
  [FIELD_NAMES.FULL_NAME]: "",
  [FIELD_NAMES.MOBILE_NUMBER]: "",
  [FIELD_NAMES.PASSWORD]: "",
  [FIELD_NAMES.PASSWORD_REPEAT]: "",
  [FIELD_NAMES.AGREEMENT]: false,
  [FIELD_NAMES.MARKETING]: false,
};
